import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DateRangeTwoTone } from "@material-ui/icons";
import Link from "next/link";

import AddReport from "../AddReport";
import ReportsHistoryTable from "../ReportsHistoryTable";
import { setReports } from "../../../store/actions/reportActions";
import ReportsBuilderStyles from "./ReportsBuilderStyles";
import LCButton from "../../styles/LCButton";

const ReportsBuilder = () => {
  const dispatch = useDispatch();

  const domain = useSelector((state) => state.domains.currentDomain);
  const reportsObj = useSelector((state) => state.reports);

  useEffect(() => {
    if (domain !== null) {
      dispatch(setReports(domain._id));
    }
  }, [domain]);

  const reports = reportsObj.reports.slice(0, 3);

  return (
    <ReportsBuilderStyles>
      <h3>Recent Reports</h3>
      <div className="addButton">
        <AddReport />
      </div>
      <ReportsHistoryTable reports={reports} domain={domain} />
      <div className="historyButtonContainer">
        <Link href="/reports/history">
          <LCButton type="primary">
            <DateRangeTwoTone className="icon" />
            Report History
          </LCButton>
        </Link>
      </div>
    </ReportsBuilderStyles>
  );
};

export default ReportsBuilder;
